import React, { useEffect, useState } from 'react';
import {
	Card,
	CardBody,
	CardHeader,
	CardHeaderToolbar,
} from '../../../../_metronic/_partials/controls';
import Table, {
	dateFormatter,
	buttonsStyle
} from '../../../components/tables/table';
import ConfirmDialog from '../../../components/dialogs/ConfirmDialog';
import { getNutritionistCertifications, deleteNutritionistCertification, changeStatusNutritionistCertification } from '../../../../api/nutritionistCertification';
import { Button, Tooltip } from '@material-ui/core';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { alertError, alertSuccess } from '../../../../utils/logger';
import { useHistory } from 'react-router-dom';
import ToggleOffIcon from '@material-ui/icons/ToggleOff';
import ToggleOnIcon from '@material-ui/icons/ToggleOn';
import { shallowEqual, useSelector } from 'react-redux';
import { getNonEmpty } from '../../../../utils/helpers';

function getData(nutritionistCertifications) {
	let data = [];
	for (let i = 0; i < nutritionistCertifications.length; ++i) {
		const elem = {};
		elem.name = getNonEmpty(nutritionistCertifications[i].fullName);
		elem.createdAt = nutritionistCertifications[i].createdAt;
		elem.id = nutritionistCertifications[i]._id;
		elem.active = nutritionistCertifications[i].active;
		data = data.concat(elem);
	}
	return data;
}

export default function NutritionistCertificationsPage() {
	const [data, setData] = useState([]);
	const [nutritionistCertificationId, setNutritionistCertificationId] = useState(null);
	const [openConfirmDialog, setOpenConfirmDialog] = useState(null);
	const [refresh, setRefresh] = useState(false);
	const history = useHistory();
	const user = useSelector((store) => store.authentication?.user, shallowEqual)

	function buttonFormatter(cell) {
		const elem = data.find(item => item.id === cell)
		return (
			<>
				<Tooltip title='Edit'>
					<Button
						style={buttonsStyle}
						size='small'
						onClick={() => history.push('/edit-nutritionist-certification/' + cell)}>
						<EditIcon />
					</Button>
				</Tooltip>
				{user?.role.includes('admin') && <>
					<Tooltip title={elem?.active ? "Disable" : "Enable"}>
						<Button
							style={buttonsStyle} size="small"
							onClick={() => {
								setNutritionistCertificationId(elem)
								setOpenConfirmDialog(1)
							}}>
							{elem?.active ? <ToggleOffIcon/> : <ToggleOnIcon style={{ color: 'red' }} />}
						</Button>
					</Tooltip>
					<Tooltip title='Delete'>
						<Button
							style={buttonsStyle}
							size='small'
							onClick={() => {
								setNutritionistCertificationId(cell);
								setOpenConfirmDialog(2);
							}}>
							<DeleteIcon />
						</Button>
					</Tooltip>
				</>}
			</>
		);
	}

	const columns = [
		{ dataField: 'name', text: 'Full name', sort: true },
		{
			dataField: 'createdAt',
			text: 'Created at',
			formatter: dateFormatter,
			sort: true,
		},
		{ dataField: 'id', text: '', formatter: buttonFormatter },
	];

	useEffect(() => {
		getNutritionistCertifications()
			.then((res) => {
				if (res.status === 200) {
					setData(getData(res.data));
					setRefresh(false);
				}
			})
			.catch((error) => {
				alertError({ error: error, customMessage: 'Could not get nutritionist certifications.' });
			});
	}, [refresh]);

	return (
		<>
			<Card>
				<CardHeader title='Nutritionist certifications list'>
					<CardHeaderToolbar>
						<button
							type='button'
							className='btn btn-primary'
							onClick={() => history.push('/edit-nutritionist-certification')}>
							Add new
						</button>
					</CardHeaderToolbar>
				</CardHeader>
				<CardBody>
					<Table data={data} columns={columns} />
					<ConfirmDialog
						title={`Are you sure you want to ${nutritionistCertificationId?.active ? 'disable' : 'enable'} this nutritionist certification?`}
						open={openConfirmDialog === 1}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							changeStatusNutritionistCertification(nutritionistCertificationId.id, !nutritionistCertificationId?.active)
								.then((res) => {
									if (res.status === 200) {
										alertSuccess({ title: `${nutritionistCertificationId?.active ? 'Disabled!' : 'Enabled!'}`, customMessage: `nutritionist certification ${nutritionistCertificationId?.active ? 'disabled' : 'enabled'} successfully` })
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({ error: error, customMessage: `Could not ${nutritionistCertificationId?.active ? 'disable' : 'enable'} nutritionist certification.` })
								});
						}}
					/>
					<ConfirmDialog
						title={'Are you sure you want to remove this nutritionist certification?'}
						open={openConfirmDialog === 2}
						setOpen={setOpenConfirmDialog}
						onConfirm={() => {
							deleteNutritionistCertification(nutritionistCertificationId)
								.then((res) => {
									if (res.status === 204 || res.status === 200) {
										alertSuccess({
											title: 'Deleted!',
											customMessage: 'nutritionist certification removed successfully.',
										});
										setRefresh(true);
									}
								})
								.catch((error) => {
									alertError({
										error: error,
										customMessage: 'Could not remove nutritionist certification.',
									});
								});
						}}
					/>
				</CardBody>
			</Card>
		</>
	);
}
